export default class PopinVideo{
    
    constructor() {
        
        this.bindEvents();
    }
    
    bindEvents(){
        document.addEventListener('click', (e) => {
            let _target = false;
            
            //Open
            if(e.target.classList.contains('js-popin-video-trigger')){
                _target = e.target;
            }
            else if(e.target.closest('.js-popin-video-trigger')){
                _target = e.target.closest('.js-popin-video-trigger');
            }
            
            if(_target){
                if(_target.getAttribute('data-popin-video-only-desktop')){
                    if(!this.isMobile()){
                        this.openPopin(_target.getAttribute('data-popin-video-id'));
                    }
                }
                else{
                    this.openPopin(_target.getAttribute('data-popin-video-id'));
                }
            }
            
            //Close
            if(e.target.classList.contains('js-popin-video-close') || e.target.closest('.js-popin-video-close')){
                this.closePopin();
            }
        });
    }
    
    openPopin(id){
       this._popin = document.querySelector('.js-popin-video[data-id="'+id+'"]');
       this._popin.classList.add('is-open');
       this.player = this._popin.querySelector('media-player');
       this.player.play();
    }
    
    
    closePopin(){
        this._popin.classList.remove('is-open');
        this.player.pause();
        this.player.currentTime = 0;
    }
    
    isMobile(){
        return window.matchMedia('(max-width:576px)').matches;
    }
}